// URL pubblico dell'app metal-class (da variabile d'ambiente)
export const APP_URL = process.env.REACT_APP_MTH_APP_URL;

// Email di contatto per le richieste di prova gratuita
export const CONTACT_EMAIL = "metalclass.register@gmail.com";

export const scrollToId = (id) => {
  const el = document.querySelector(id);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -72, duration: 1.4 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};
